import React            from 'react';
import {
    Route,
}                       from "react-router-dom";

import Role             from 'utils/Role';
import App              from 'App';

import AEVApplication   from './AEVApplication';

export const Index = ( app:App ) : Role => {
    const roleRoot          = "/Applicant";
    return {
        name   : "Applicant",
        root   : roleRoot,
        items  : [],
        routes : [
            <Route
                key={"applicant_adaeligibiliy"}
                path={`${roleRoot}/AEVApplication/:id`}
                element={<AEVApplication/>} />,
            <Route
                key={"applicant"}
                path={roleRoot}
                element={<AEVApplication/>} />,
        ]
    };
}

export default Index;
